export default {
  title: 'Prämien',
  guest: {
    eyebrow: 'Prämien',
    headline: 'Sammle Punkte mit jeder Bestellung',
    subheading_one: 'Für je {{amount}} Bestellwert erhältst du {{count}} Punkt.',
    subheading_other: 'Für je {{amount}} Bestellwert erhältst du {{count}} Punkte.',
    cta: 'Registrieren & sammeln',
    already_member: 'Schon Mitglied?',
    sign_in: 'Anmelden',
    redeemable_heading: 'Deine Punkte = Gratis-Essen',
    redeemable_eyebrow: '🎁 Das kannst du freischalten',
  },
  member: {
    balance_label: 'Dein Guthaben',
    balance_suffix: 'Punkte · Wert <highlight>{{amount}}</highlight>',
    next_reward: 'Nächste Prämie bei <highlight>{{points}} Pkt.</highlight>',
    redeem_hint: '✓ Du kannst bei deiner nächsten Bestellung bis zu {{points}} Pkt. ({{amount}}) einlösen',
    expiration_zero: '⏳ {{points}} Pkt. verfallen heute',
    expiration_one: '⏳ {{points}} Pkt. verfallen in 1 Tag',
    expiration_other: '⏳ {{points}} Pkt. verfallen in {{count}} Tagen',
    pts_lifetime: 'Pkt. gesamt',
    saved_lifetime: 'Gespart gesamt',
    cta: 'Jetzt bestellen',
    redeemable_heading: 'Was du einlösen kannst',
    redeemable_eyebrow: 'Du hast {{points}} Pkt. ({{amount}})',
    redeemable_description:
      'Bis zu {{maxPoints}} Pkt. ({{maxAmount}}) pro Bestellung. Artikel unter {{maxAmount}} sind komplett gratis.',
  },
  items: {
    free: 'GRATIS',
    save: 'Spare {{amount}}',
  },
  history: {
    eyebrow: 'Verlauf',
    title: 'Letzte Aktivitäten',
    load_more: 'Mehr laden',
    sources: {
      welcome_bonus: 'Willkommensbonus',
      google_review_reward: 'Google-Bewertungsprämie',
      reward_loyalty_program_conversion: 'Treueprogramm-Umstellung',
      cashback: 'Cashback erhalten',
      refund: 'Bestellung erstattet',
      cashback_usage: 'Punkte eingelöst',
      cashback_usage_refund: 'Einlösung erstattet',
      expired_points_void: 'Punkte abgelaufen',
      mobile_app_signup_bonus: 'App-Anmeldebonus',
    },
    detail_with_order: 'Bestellung #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Einfach & automatisch',
    eyebrow_member: 'Kurze Erinnerung',
    title: 'So funktioniert es',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Gratis registrieren',
        desc: 'Konto in 30 Sekunden erstellen.',
      },
      order: {
        emoji: '🍔',
        title: 'Bestellen & sammeln',
        desc_one: '1 Pkt. pro {{amount}} — automatisch.',
        desc_other: '{{count}} Pkt. pro {{amount}} — automatisch.',
      },
      build: {
        emoji: '⭐',
        title: 'Punkte sammeln',
        desc: 'Einlösen ab {{minPoints}} Pkt. {{lifetime}} Tage gültig.',
      },
      save: {
        emoji: '🎁',
        title: 'An der Kasse sparen',
        desc: 'Bis zu {{maxAmount}} Rabatt — sofort.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Weiter sparen',
        desc: 'Jede Bestellung erhöht dein Guthaben.',
      },
    },
  },
  faq: {
    eyebrow: 'Fragen?',
    title: 'Häufig gestellt',
    items: {
      earn: {
        q: 'Wie sammle ich Punkte?',
        a_one:
          'Für je {{amount}} Bestellwert erhältst du 1 Punkt. Die Punkte werden automatisch nach jeder Bestellung gutgeschrieben — kein Scannen, keine Codes.',
        a_other:
          'Für je {{amount}} Bestellwert erhältst du {{count}} Punkte. Die Punkte werden automatisch nach jeder Bestellung gutgeschrieben — kein Scannen, keine Codes.',
      },
      redeem: {
        q: 'Wann kann ich einlösen?',
        a: 'Du kannst ab {{minPoints}} Punkten einlösen. Nutze sie an der Kasse, um deinen Gesamtbetrag zu reduzieren.',
      },
      max: {
        q: 'Wie viel kann ich pro Bestellung sparen?',
        a: 'Du kannst pro Bestellung bis zu {{maxPoints}} Punkte ({{maxAmount}}) einlösen. Das ist der maximale Rabatt pro Checkout.',
      },
      validity: {
        q: 'Wie lange sind Punkte gültig?',
        a: 'Punkte sind {{lifetime}} Tage ab dem Zeitpunkt gültig, an dem sie gesammelt wurden. Nutze sie, bevor sie ablaufen!',
      },
    },
  },
};
